import { connect } from 'react-redux'
import Logout from './Logout'

const mapStateToProps = () => ({
})

export default connect(mapStateToProps)(Logout)
